module.exports = __webpack_public_path__ + "static/media/8.c37e71a8.png";